import { render } from "./ButtonInput.vue?vue&type=template&id=70c2daa4&scoped=true"
import script from "./ButtonInput.vue?vue&type=script&lang=js"
export * from "./ButtonInput.vue?vue&type=script&lang=js"

import "./ButtonInput.vue?vue&type=style&index=0&id=70c2daa4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c2daa4"]])

export default __exports__